import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PromptCloneService {
  private clonedPromptData: any | null = null;

  // Store cloned data
  setClonedPromptData(promptData: any): void {
    this.clonedPromptData = promptData;
  }

  // Retrieve cloned data
  getClonedPromptData(): any | null {
    return this.clonedPromptData;
  }

  // Check if data is cloned
  hasClonedPromptData(): boolean {
    return this.clonedPromptData !== null;
  }

  // Clear cloned data
  clearClonedPromptData(): void {
    this.clonedPromptData = null;
  }
}
